import { FC } from 'react'
import { Flex, Tag } from 'antd'

interface UserOptionLabelProps {
    username: string
    activeTasksCount: number
}

const UserOptionLabel: FC<UserOptionLabelProps> = ({ username, activeTasksCount }) => {
    return (
        <Flex justify='space-between' align='center' gap={8}>
            <span>{username}</span>
            <Tag>{activeTasksCount}</Tag>
        </Flex>
    )
}

export default UserOptionLabel
